class UsuarioModel {

    id: number | null;
    name: string | null;
    email: string | null;
    password: string | null;

    constructor() {
        this.id = null;
        this.name = null;
        this.email = null;
        this.password = null;
    }

}

export default UsuarioModel;
